<template>
    <div class="etusivu">
        <p><span class="etusivu-app-name">{{ $t("App.Etusivu.AppName") }} </span> {{ $t("App.Etusivu.Content") }}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"

    @Component
    export default class Etusivu extends Vue {
        async activated() {
            // Tyhjennetään kartta
            this.$store.dispatch("setDataUrlToLoad", null)
        }
    }
</script>

<style scoped>
    .etusivu-app-name {
        color: var(--Traficom-main-color);
    }
</style>
